import React from "react";

export default function QuizSkeleton() {
  return (
    <div className="space-y-4">
      <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/60">
        <div className="h-4 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="mt-3 h-3 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1.05fr)_minmax(320px,0.95fr)]">
        <div className="h-[360px] animate-pulse rounded-[1.75rem] bg-slate-200 dark:bg-slate-800 sm:h-[440px]" />

        <div className="space-y-3">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="h-14 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800"
            />
          ))}

          <div className="h-14 animate-pulse rounded-2xl bg-slate-300 dark:bg-slate-700" />
        </div>
      </div>
    </div>
  );
}